import { tv } from "tailwind-variants";

export const card = tv({
    slots: {
        base: "card",
        body: "card-body",
        footer: "card-footer",
        header: "card-header",
        image: "card-img",
        text: "card-text",
        title: "card-title",
        link: "card-link"
    },
    variants: {
        imgAlignment: {
            top: { image: "card-img-top" },
            bottom: { image: "card-img-bottom" }
        },
        border: {
            true: { base: "tw:border" },
            false: { base: "tw:border-none", image: "tw:rounded-none!" }
        }
    },
    defaultVariants: {
        border: true
    }
});
